var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navleft-db floatL"},[_c('ul',_vm._l((_vm.navList),function(item){return (_vm.curNav.pid != 0 || _vm.curNav.id==item.id)?_c('li',{class:_vm.curNav.id==item.id?'cur':''},[_c('a',{attrs:{"href":item.web_url!=''?item.web_url:'javascript:void(0)'}},[_vm._v(_vm._s(item.name))])]):_vm._e()}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd49c56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/navleft.vue
// module id = null
// module chunks = 